import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface LinkedAccountDetailRowProps {
  icon: React.ReactNode;
  iconBgColor: string;
  label: string;
  value?: string;
}

export const LinkedAccountDetailRow: React.FC<LinkedAccountDetailRowProps> = React.memo(({
  icon,
  iconBgColor,
  label,
  value,
}) => {
  const { colors } = useThemeColors();

  return (
    <View style={styles.row}>
      <View style={[styles.iconCircle, { backgroundColor: iconBgColor }]}>
        {icon}
      </View>
      <Text style={[styles.text, { color: colors.text.subtle }]} numberOfLines={1}>
        <Text style={[styles.label, { color: colors.text.subtle }]}>{label}</Text>
        {value ? <Text style={{ color: colors.text.muted, fontWeight: '500' }}> {value}</Text> : null}
      </Text>
    </View>
  );
});

LinkedAccountDetailRow.displayName = 'LinkedAccountDetailRow';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    height: 40,
  },
  iconCircle: {
    width: 28,
    height: 28,
    borderRadius: 7,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    flex: 1,
    ...REDESIGN_TYPOGRAPHY.small,
    fontWeight: '400',
  },
  label: {
    fontWeight: '400',
  },
});
